import React, { Component } from 'react';
import * as BinToBinAction from '../actions/BinToBinAction';
import BinToBinStore from '../stores/BinToBinStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next';
import * as MenuAction from '../actions/MenuAction';
import swal from 'sweetalert';
import ReactPaginate from 'react-paginate';
let currentPagePath;
let isFromFieldInventory = false;
let ItemID = "";
let proceed = true;
let ShortDesc = "";
let Serial_ID = "";
let actual_qty = "";
let MFG = "";
let MFGID = "";
let UOM = "";
let Image_URL = "";
let VendorID = "";
let DeleteFlag = false;

class BinToBinComponent extends Component {
    constructor(props) {
        super(props);
        let checkedItems = props.location.state && props.location.state.checkedItems
            ? props.location.state.checkedItems.map(item => ({
                ...item,
                QUANTITY: item.actual_qty // Initialize quantity to 1 for each checked item
            }))
            : [];
        this.state = {
            AdjustedQty: "",
            Quantity: "",
            ItemID: "",
            MakeDefchk: false,
            TransQuantity: "",
            isFavorited: false,
            ItemDescription: "",
            SerialId: "",
            SelectedUOM: "",
            TransferMessage: "",
            PhyInvMsg: "",
            SelectedOrigArea: "",
            SelectedOrigAisle: "",
            SelectedOrigRow: "",
            SelectedOrigShelf: "",
            SelectedOrigBin: "",
            SelectedDestArea: "",
            SelectedDestAisle: "",
            SelectedDestRow: "",
            SelectedDestShelf: "",
            SelectedDestBin: "",
            OrigLocGrid: [],
            DestLocGrid: [],
            Area: [],
            SelectedOrigBU: "",
            Aisle: [],
            Row: [],
            Shelf: [],
            Bin: [],
            SelectedCurQty: "",
            DefArea: [],
            SelectedBuName: "",
            ItemDefBin: "",
            ItemDefShelf: "",
            ItemDefRow: "",
            ItemDefAisle: "",
            ItemDefArea: "",
            ItemDefArea: "",
            truckUser: (this.props.location && this.props.location.state && this.props.location.state.isFromFieldInventory) ?"True" : CookieService.getLocalStorageValues("Session_TRUCK_USER") ,
            CartData: [],
            TechNameValue: "",
            TruckidValue: "",
            TechNameDD: [],
            TruckidDD: [],
            isFromFieldInventory: (this.props.location && this.props.location.state && this.props.location.state.isFromFieldInventory) ? true : false,
            itemDetailShow: (this.props.location && this.props.location.state && this.props.location.state.isFromFieldInventory) ? true : false,
            TruckFieldQty: 1,
            PageNo: 1,
            totalCount: 0,
            RecCount: 10,
            PageCount: 0,
            TransferEditPopUp: [],
            itemToDelete: null,
            deleteFlag: false,
            confirmationMessage: '',
            checkedItems,
            quantityErrors: [],
        }

        if (this.state.isFromFieldInventory) {
            isFromFieldInventory = this.props.location.state.isFromFieldInventory;
            ItemID = this.props.location.state.inv_item_id;
            ShortDesc = this.props.location.state.short_desc;
            Serial_ID = this.props.location.state.serial_id;
            actual_qty = this.props.location.state.actual_qty;
            MFG = this.props.location.state.mfg_std;
            MFGID = this.props.location.state.manufacturer_part_number;
            UOM = this.props.location.state.uom;
            Image_URL = this.props.location.state.image_list;
            VendorID = this.props.location.state.vendor_id;
        }
    }
    /***
     * BTB_PC_07 - Deepthi N H
     * */
    componentDidMount() {
        //debugger
        window.scrollTo(0, 0)
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == undefined || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == null ||
            CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == "" || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT").trim() == "") {
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        BinToBinAction.getCurrentFavPage(getFavPageBO);

        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == null || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == undefined ||
            CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == "" || CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") == " ") {
            let cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Select and Save the Crib Identitifer in the user profile."
            });
            this.props.history.push({
                pathname: `/profile`,
                state: { origin: 'Inventory' }
            });
            return;
        }
        if (isFromFieldInventory) {
            CookieService.updateLocalStorageValues("FieldInventory_RegionDD", this.props.location.state.RegionDD);
            CookieService.updateLocalStorageValues("FieldInventory_SubRegionDD", this.props.location.state.SubRegionDD);
            CookieService.updateLocalStorageValues("FieldInventory_TruckidDD", this.props.location.state.TruckidDD);
            CookieService.updateLocalStorageValues("FieldInventory_TechNameDD", this.props.location.state.TechNameDD);
            CookieService.updateLocalStorageValues("FieldInventory_RegionValue", this.props.location.state.RegionValue);
            CookieService.updateLocalStorageValues("FieldInventory_SubRegionValue", this.props.location.state.SubRegionValue);
            CookieService.updateLocalStorageValues("FieldInventory_TruckidValue", this.props.location.state.TruckidValue);
            CookieService.updateLocalStorageValues("FieldInventory_TechNameValue", this.props.location.state.TechNameValue);
            CookieService.updateLocalStorageValues("FieldInventory_SearchTxt", this.props.location.state.SearchTxt);
            CookieService.updateLocalStorageValues("FieldInventory_UserId", this.props.location.state.UserId);
            CookieService.updateLocalStorageValues("FieldInventory_PageLoadData", this.props.location.state.PageLoadData);
            CookieService.updateLocalStorageValues("FieldInventory_IncludeZeroCheck", this.props.location.state.IncludeZeroCheck);
        }
        if (this.state.truckUser == "True") {
            this.TruckPageLoad();
        }
        if (!isFromFieldInventory) {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        }
        BinToBinStore.on('TruckPageLoad', this.TruckPageLoadResponse);
        BinToBinStore.on('SearchItem', this.SearchItemClickResponse);
        BinToBinStore.on('updateTransferAction', this.updateTransferActionResponse);
        BinToBinStore.on('TransferConfSubmit', this.TransferConfClickResponse);
        BinToBinStore.on('favpage', this.loadFavPageResponse.bind(this));
        BinToBinStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
        BinToBinStore.on('insertTransferAction', this.insertTransferActionResponse);
        BinToBinStore.on('TruckTransferSubmit', this.TruckTransferSubmitResponse);
        BinToBinStore.on('DeleteUnavailableItems', this.DeleteUnavailableItemsResponse);
    }
    /***
     * BTB_PC_07 - Deepthi N H
     * */
    componentWillUnmount() {
        isFromFieldInventory = "";
        ItemID = "";
        ShortDesc = "";
        Serial_ID = "";
        actual_qty = "";

        BinToBinStore.removeListener('TruckPageLoad', this.TruckPageLoadResponse);
        BinToBinStore.removeListener('insertTransferAction', this.insertTransferActionResponse);
        BinToBinStore.removeListener('updateTransferAction', this.updateTransferActionResponse);
        BinToBinStore.removeListener('SearchItem', this.SearchItemClickResponse);
        BinToBinStore.removeListener('TransferConfSubmit', this.TransferConfClickResponse);
        BinToBinStore.removeListener('favpage', this.loadFavPageResponse.bind(this));
        BinToBinStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
        BinToBinStore.removeListener('TruckTransferSubmit', this.TruckTransferSubmitResponse);
        BinToBinStore.removeListener('DeleteUnavailableItems', this.DeleteUnavailableItemsResponse);


    }


    TruckPageLoad = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let pageLoadBO = {
            UserID: CookieService.getLocalStorageValues("Session_UserID") == "" || undefined || null ? "" : CookieService.getLocalStorageValues("Session_UserID"),
            ShipTo: CookieService.getLocalStorageValues("Session_TRUCK_USER") ? (CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : " ",

        }
        BinToBinAction.TruckPageLoad(pageLoadBO);
    }
    TruckPageLoadResponse = () => {
        const pageLoadData = JSON.parse(BinToBinStore.TruckPageLoad);
        let selectall = [];
        let TechNameDD = [];
        let TruckidDD = [];
        let unavailableItems = [];
        if (isFromFieldInventory) {
            CookieService.updateLocalStorageValues("FieldInventory_cleardata", true);
        } else {
            CookieService.updateLocalStorageValues("FieldInventory_cleardata", false);
        }
        if (pageLoadData === "Technical issue") {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue."
            });
            return;
        }

        let fullData = pageLoadData.EmployeeDetails;
        let CartData = pageLoadData.TransferItems;
        let pageCount = parseFloat(CartData.length) / 10
        fullData.forEach(item => {

            if (!TechNameDD.some(tech => tech.value === item.ISA_USER_NAME)) {
                let Tech = item.ISA_USER_NAME.replace(',', ', ');
                let obj = { value: item.ISA_USER_NAME, label: Tech };
                TechNameDD.push(obj);
            }

            if (!TruckidDD.some(truck => truck.value === item.STORAGE_AREA)) {
                let Truck = item.STORAGE_AREA;
                let obj = { value: item.STORAGE_AREA, label: item.TRUCK_ID_DESCR };
                TruckidDD.push(obj);
            }
        })
        TechNameDD = TechNameDD.sort((a, b) => a.label.localeCompare(b.label));



        TechNameDD = [...TechNameDD];
        TruckidDD = [...TruckidDD];
        CartData.forEach(item => {
            if (item.IsQtyAvailable === true) {
                unavailableItems.push(item);
            }
        });

        if (unavailableItems.length > 0) {
            $('#QTY-popupbintobin').modal('show');
        }

        this.setState({ TechNameDD, TruckidDD, CartData, PageLoadData: fullData, unavailableItems, pageCount });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    HandleChangeDD = (selectedOption, type) => {
        let techNameDD = [];
        let truckidDD = [];
        let truckidValue = "";
        let techNameValue = "";
        let userId = "";
        let defaultTruck = null;
        let label = "";

        switch (type) {
            case "TruckID":
                truckidValue = selectedOption.value;

                // Filter tech names by selected Truck ID
                this.state.PageLoadData.forEach(item => {
                    if (item.STORAGE_AREA === truckidValue) {
                        if (!techNameDD.find(tech => tech.value === item.ISA_USER_NAME)) {
                            userId = item.ISA_EMPLOYEE_ID;
                            let techNameLabel = item.ISA_USER_NAME.replace(',', ', ');
                            techNameDD.push({ value: item.ISA_USER_NAME, label: techNameLabel });
                            label = item.TRUCK_ID_DESCR;
                        }
                    }
                });

                techNameDD = techNameDD.sort((a, b) => a.label.localeCompare(b.label));
                const prefillTechNameValue = techNameDD.length > 0 ? techNameDD[0] : '';

                this.setState({
                    TruckidValue: { value: truckidValue, label: label },
                    TechNameDD: techNameDD,
                    TechNameValue: prefillTechNameValue,
                    UserId: userId
                });
                break;

            case "Tech":
                techNameValue = selectedOption.value;

                // Filter truck IDs corresponding to the selected tech name and get the user id
                this.state.PageLoadData.forEach(item => {
                    if (item.ISA_USER_NAME === techNameValue) {
                        userId = item.ISA_EMPLOYEE_ID;
                        if (!truckidDD.find(truck => truck.value === item.STORAGE_AREA)) {
                            truckidDD.push({ value: item.STORAGE_AREA, label: item.TRUCK_ID_DESCR });
                        }
                        // Check if DEFAULT_FLG is "Y"
                        if (item.DEFAULT_FLG === "Y") {
                            defaultTruck = item.STORAGE_AREA;
                            label = item.TRUCK_ID_DESCR;
                        }
                    }
                });

                truckidDD = truckidDD.sort((a, b) => a.label.localeCompare(b.label));

                // If no default found, select the first truck ID
                if (!defaultTruck && truckidDD.length > 0) {
                    defaultTruck = truckidDD[0].value;
                }

                this.setState({
                    TechNameValue: { value: techNameValue, label: techNameValue }, // Set selected tech name
                    TruckidValue: { value: defaultTruck, label: label }, // Prefill with the truck ID where DEFAULT_FLG is "Y" or the first truck ID
                    TruckidDD: truckidDD,  // Set filtered truck IDs
                    UserId: userId // Set the userId
                });
                break;

            default:
                break;
        }
    }
    DeleteUnavailableItemsResponse = () => {
        const response = JSON.parse(BinToBinStore.DeleteUnavailableItems);
        if (response === 'Technical issue') {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Technical Issue. Please contact SDI Customer Care'
            });
        } else {
            let pageCount = parseFloat(response.TransferItems.length) / 10
            this.setState({ CartData: response.TransferItems, pageCount });
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /***
     * BTB_PC_09 - Deepthi N H
     * */
    OnHandleChange = (e, type) => {
        //debugger
        const re = SDIConstants.quantityRegEX;
        const value = e.target.value;
        let regex = SDIConstants.alphanumericRegex;
        if (type === "ItemID") {
            if (regex.test(value) || value == '') {
                this.setState({ [e.target.name]: value });
            }
        }
        else if (type == "TransQuantity") {
            //debugger;
            if (value === '' || re.test(value)) {
                if (value != "0") {
                    this.setState({ [e.target.name]: value });
                }
            }
        }
        else if (type == "checkbox") {
            this.setState({ MakeDefchk: e.target.checked });
        }

    };




    // To handle Radio button in the Inventory location grid
    OnHandleGridRadChange = (e, Gindex) => {
        //debugger
        let locGrid = this.state.OrigLocGrid;
        if (locGrid.length == 1) {
            return;
        }
        else if (locGrid.length > 1) {
            locGrid.forEach((value, index) => {
                if (index == Gindex) {
                    value.IsLocSelected = e.target.checked;
                    //WBW-19 Bin-to-Bin Transfer Bugs-Deepthi
                    let destArea = {
                        value: value.STORAGE_AREA,
                        label: value.STORAGE_AREA
                    }
                    let destAisle = {
                        value: value.STOR_LEVEL_1,
                        label: value.STOR_LEVEL_1
                    }
                    let destrow = {
                        value: value.STOR_LEVEL_2,
                        label: value.STOR_LEVEL_2
                    }
                    let destshelf = {
                        value: value.STOR_LEVEL_3,
                        label: value.STOR_LEVEL_3
                    }
                    let destbin = {
                        value: value.STOR_LEVEL_4,
                        label: value.STOR_LEVEL_4
                    }
                    let Areadd = [];
                    this.state.DestLocGrid.map((item, index) => {
                        if (item.BUSINESS_UNIT == value.BUSINESS_UNIT && Areadd.indexOf(item.STORAGE_AREA) == -1) {
                            let obj = {
                                value: item.STORAGE_AREA,
                                label: item.STORAGE_AREA
                            }
                            Areadd.push(obj);
                        }
                    })
                    let locArea = Areadd.filter((ele, ind) => ind === Areadd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                    locArea.sort((a, b) => a.label > b.label ? 1 : -1);
                    let Aisledd = [];
                    this.state.DestLocGrid.map((item, index) => {
                        if (item.STORAGE_AREA == value.STORAGE_AREA && Aisledd.indexOf(value.STOR_LEVEL_1) == -1) {
                            let obj = {
                                value: item.STOR_LEVEL_1,
                                label: item.STOR_LEVEL_1
                            }
                            Aisledd.push(obj);
                        }
                    })
                    let ppaisle = Aisledd.filter((ele, ind) => ind === Aisledd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                    ppaisle.sort((a, b) => a.label > b.label ? 1 : -1);
                    let Rowdd = [];
                    this.state.DestLocGrid.map((item, index) => {
                        if (item.STORAGE_AREA == value.STORAGE_AREA && item.STOR_LEVEL_1 == value.STOR_LEVEL_1
                            && Rowdd.indexOf(item.STOR_LEVEL_2) == -1
                        ) {
                            let obj = {
                                value: item.STOR_LEVEL_2,
                                label: item.STOR_LEVEL_2
                            }
                            Rowdd.push(obj);
                        }
                    })
                    let pprow = Rowdd.filter((ele, ind) => ind === Rowdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
                    pprow.sort((a, b) => a.label > b.label ? 1 : -1);
                    let Shelfdd = [];
                    this.state.DestLocGrid.map((item, index) => {
                        if (item.STORAGE_AREA == value.STORAGE_AREA && item.STOR_LEVEL_1 == value.STOR_LEVEL_1
                            && item.STOR_LEVEL_2 == value.STOR_LEVEL_2 && Shelfdd.indexOf(item.STOR_LEVEL_3) == -1
                        ) {
                            let obj = {
                                value: item.STOR_LEVEL_3,
                                label: item.STOR_LEVEL_3
                            }
                            Shelfdd.push(obj);
                        }
                    })
                    let ppshelf = Shelfdd.filter((ele, ind) => ind === Shelfdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label));
                    ppshelf.sort((a, b) => a.label > b.label ? 1 : -1);
                    let Bindd = [];
                    this.state.DestLocGrid.map((item, index) => {
                        if (item.STORAGE_AREA == value.STORAGE_AREA && item.STOR_LEVEL_1 == value.STOR_LEVEL_1
                            && item.STOR_LEVEL_3 == value.STOR_LEVEL_3 && item.STOR_LEVEL_2 == value.STOR_LEVEL_2 && Bindd.indexOf(item.STOR_LEVEL_4) == -1
                        ) {
                            let obj = {
                                value: item.STOR_LEVEL_4,
                                label: item.STOR_LEVEL_4
                            }
                            Bindd.push(obj);
                        }
                    })
                    let ppbin = Bindd.filter((ele, ind) => ind === Bindd.findIndex(elem => elem.value === ele.value && elem.label === ele.label));
                    ppbin.sort((a, b) => a.label > b.label ? 1 : -1);
                    this.setState({
                        OrigLocGrid: locGrid, ItemDescription: value.DESCR254, SelectedOrigArea: value.STORAGE_AREA, SelectedDestArea: destArea, SelectedDestAisle: destAisle, SelectedDestRow: destrow,
                        SelectedDestShelf: destshelf, SelectedDestBin: destbin, Area: locArea, Aisle: ppaisle, Row: pprow, Shelf: ppshelf, Bin: ppbin,
                        SelectedOrigAisle: value.STOR_LEVEL_1, SelectedOrigRow: value.STOR_LEVEL_2, SelectedOrigShelf: value.STOR_LEVEL_3, SelectedOrigBin: value.STOR_LEVEL_4, SelectedBuName: value.DESCR, SelectedOrigBU: value.BUSINESS_UNIT, SelectedCurQty: value.QuantityAvail
                    });
                }
                else {
                    value.IsLocSelected = !e.target.checked;
                }
            });
        }
    }
    /***
     * BTB_PC_10 - Deepthi N H
     * */
    SearchItemClick = () => {

        if (this.state.ItemID != "") {
            let SearchItemBO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                ItemId: this.state.ItemID.toUpperCase(),
                UserId: CookieService.getLocalStorageValues("Session_UserID"),
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            BinToBinAction.SearchItem(SearchItemBO)
            //[9/14/2022]2652 - Bin to Bin Transfer_ Able to Current locations of the previous items even though invalid item id / no item id is provided. - Dhamotharan P
            this.setState({
                SelectedOrigArea: [], SelectedOrigAisle: [], SelectedOrigRow: [], ItemDescription: [], ItemDefBUName: [], ItemDefArea: [], ItemDefAisle: [], ItemDefRow: [], ItemDefShelf: [], ItemDefBin: [],
                SelectedOrigShelf: [], SelectedOrigBin: [], OrigLocGrid: [], DestLocGrid: [], SelectedOrigBU: [], SelectedBuName: [], SelectedCurQty: [], TransQuantity: []
            });
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter item ID'
            });
            //alert('Please Enter Item Id');
        }

    }
    /***
     * BTB_PC_17 - Deepthi N H
     * */
    SearchItemClickResponse = () => {

        let SearchItemData = JSON.parse(BinToBinStore.SearchItemData);
        //WW - 396 Bin - To - Bin transfer page Default Location is showing the PHYSICAL_INV location; needs to show DEFAULT_LOC_INV location - Deepthi
        let PhyInv = SearchItemData.PhysInvDesc;
        if (PhyInv == undefined) {
            let ItemDescArray = SearchItemData.ItemDescDt;
            let ItemOrigArray = SearchItemData.ItemOrigDt;
            let ItemDestArray = SearchItemData.ItemDestDt;
            if (ItemDescArray == undefined && ItemOrigArray == undefined && ItemDestArray == undefined) {

                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib id from user Profile"
                });
            }
            else {
                let ItemDesc = ItemDescArray[0].ItemDescription;
                if (ItemDesc == null || ItemDesc == undefined || ItemDesc == "") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Please enter a valid item ID"
                    });

                }
                else {
                    if (ItemOrigArray.length > 0 && ItemDestArray.length > 0) {
                        let DefLoc = ItemOrigArray[0].DEFLOC;
                        //WW-558_PC_01 (12/16/2022)-Aparna
                        let SplitedDefLoc = []

                        if (DefLoc != null && DefLoc != undefined) {
                            SplitedDefLoc = DefLoc.split('|');
                        }
                        ItemOrigArray.forEach((value, index) => {
                            value.IsLocSelected = false;
                        });
                        ItemOrigArray[0].IsLocSelected = true;
                        this.BuildDefLocDD(ItemOrigArray, ItemDestArray);
                        console.log("testdef", this.state.SelectedDestArea.value);
                        console.log("testdef1", this.state.SelectedDestAisle.value);
                        console.log("testdef2", this.state.SelectedDestRow.value);
                        console.log("testdef3", this.state.SelectedDestShelf.value);
                        console.log("testdef4", this.state.SelectedDestBin.value);
                        //WW-396 Bin-To-Bin transfer page Default Location is showing the PHYSICAL_INV location; needs to show DEFAULT_LOC_INV location - Deepthi
                        this.setState({
                            SelectedOrigArea: ItemOrigArray[0].STORAGE_AREA, SelectedOrigAisle: ItemOrigArray[0].STOR_LEVEL_1, SelectedOrigRow: ItemOrigArray[0].STOR_LEVEL_2, ItemDescription: ItemDesc,
                            ItemDefBUName: SplitedDefLoc[0] != null && SplitedDefLoc[0] != undefined ? SplitedDefLoc[0] : "", ItemDefArea: SplitedDefLoc[1] != null && SplitedDefLoc[1] != undefined ? SplitedDefLoc[1] : "",
                            ItemDefAisle: SplitedDefLoc[2] != null && SplitedDefLoc[2] != undefined ? SplitedDefLoc[2] : "", ItemDefRow: SplitedDefLoc[3] != null && SplitedDefLoc[3] != undefined ? SplitedDefLoc[3] : "",
                            ItemDefShelf: SplitedDefLoc[4] != null && SplitedDefLoc[4] != undefined ? SplitedDefLoc[4] : "", ItemDefBin: SplitedDefLoc[5] != null && SplitedDefLoc[5] != undefined ? SplitedDefLoc[5] : "",
                            SelectedOrigShelf: ItemOrigArray[0].STOR_LEVEL_3, SelectedOrigBin: ItemOrigArray[0].STOR_LEVEL_4, OrigLocGrid: ItemOrigArray, DestLocGrid: ItemDestArray, SelectedOrigBU: ItemOrigArray[0].BUSINESS_UNIT, SelectedBuName: ItemOrigArray[0].DESCR, SelectedCurQty: ItemOrigArray[0].QuantityAvail, TransQuantity: ItemOrigArray[0].QuantityAvail
                        });
                    }
                    else {
                        this.setState({
                            ItemDescription: ItemDesc, PhyInvMsg: "Physical inventory not found for item.", OrigLocGrid: [], DestLocGrid: []
                        });
                    }
                }
            }
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: (PhyInv[0].AlertMsg)
            });
            this.setState({
                ItemDescription: PhyInv[0].ItemDescription
            });

        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    BuildDefLocDD(ItemOrigArray, ItemDestArray) {
        let Areadd = [];
        ItemDestArray.map((item, index) => {
            if (item.BUSINESS_UNIT == ItemOrigArray[0].BUSINESS_UNIT && Areadd.indexOf(item.STORAGE_AREA) == -1) {
                let obj = {
                    value: item.STORAGE_AREA,
                    label: item.STORAGE_AREA
                }
                Areadd.push(obj);
            }
        })
        let locArea = Areadd.filter((ele, ind) => ind === Areadd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        locArea.sort((a, b) => a.label > b.label ? 1 : -1);
        let DestArea = {
            value: ItemOrigArray[0].STORAGE_AREA,
            label: ItemOrigArray[0].STORAGE_AREA
        }
        let DestAisle = {
            value: ItemOrigArray[0].STOR_LEVEL_1,
            label: ItemOrigArray[0].STOR_LEVEL_1
        }
        let DestRow = {
            value: ItemOrigArray[0].STOR_LEVEL_2,
            label: ItemOrigArray[0].STOR_LEVEL_2
        }
        let DestShelf = {
            value: ItemOrigArray[0].STOR_LEVEL_3,
            label: ItemOrigArray[0].STOR_LEVEL_3
        }
        let DestBin = {
            value: ItemOrigArray[0].STOR_LEVEL_4,
            label: ItemOrigArray[0].STOR_LEVEL_4
        }
        //WBW-19 Bin-to-Bin Transfer Bugs-Deepthi
        let Aisledd = [];
        ItemDestArray.map((item, index) => {
            if (item.STORAGE_AREA == ItemOrigArray[0].STORAGE_AREA && Aisledd.indexOf(item.STOR_LEVEL_1) == -1) {
                let obj = {
                    value: item.STOR_LEVEL_1,
                    label: item.STOR_LEVEL_1
                }
                Aisledd.push(obj);
            }
        })
        let ppaisle = Aisledd.filter((ele, ind) => ind === Aisledd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        ppaisle.sort((a, b) => a.label > b.label ? 1 : -1);
        let Rowdd = [];
        ItemDestArray.map((item, index) => {
            if (item.STORAGE_AREA == ItemOrigArray[0].STORAGE_AREA && item.STOR_LEVEL_1 == ItemOrigArray[0].STOR_LEVEL_1
                && Rowdd.indexOf(item.STOR_LEVEL_2) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_2,
                    label: item.STOR_LEVEL_2
                }
                Rowdd.push(obj);
            }
        })
        let pprow = Rowdd.filter((ele, ind) => ind === Rowdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        pprow.sort((a, b) => a.label > b.label ? 1 : -1);
        let Shelfdd = [];
        ItemDestArray.map((item, index) => {
            if (item.STORAGE_AREA == ItemOrigArray[0].STORAGE_AREA && item.STOR_LEVEL_1 == ItemOrigArray[0].STOR_LEVEL_1
                && item.STOR_LEVEL_2 == ItemOrigArray[0].STOR_LEVEL_2 && Shelfdd.indexOf(item.STOR_LEVEL_3) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_3,
                    label: item.STOR_LEVEL_3
                }
                Shelfdd.push(obj);
            }
        })
        let ppshelf = Shelfdd.filter((ele, ind) => ind === Shelfdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label));
        ppshelf.sort((a, b) => a.label > b.label ? 1 : -1);
        let Bindd = [];
        ItemDestArray.map((item, index) => {
            if (item.STORAGE_AREA == ItemOrigArray[0].STORAGE_AREA && item.STOR_LEVEL_1 == ItemOrigArray[0].STOR_LEVEL_1
                && item.STOR_LEVEL_3 == ItemOrigArray[0].STOR_LEVEL_3 && item.STOR_LEVEL_2 == ItemOrigArray[0].STOR_LEVEL_2 && Bindd.indexOf(item.STOR_LEVEL_4) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_4,
                    label: item.STOR_LEVEL_4
                }
                Bindd.push(obj);
            }
        })
        let ppbin = Bindd.filter((ele, ind) => ind === Bindd.findIndex(elem => elem.value === ele.value && elem.label === ele.label));
        ppbin.sort((a, b) => a.label > b.label ? 1 : -1);
        let AreaArray = [];
        let AisleArray = [];
        let RowArray = [];
        let ShelfArray = [];
        let BinArray = [];
        AreaArray.push(DestArea);
        AisleArray.push(DestAisle);
        RowArray.push(DestRow);
        ShelfArray.push(DestShelf);
        BinArray.push(DestBin);
        this.setState({
            SelectedDestArea: AreaArray[0], SelectedDestAisle: AisleArray[0], SelectedDestRow: RowArray[0],
            SelectedDestShelf: ShelfArray[0], SelectedDestBin: BinArray[0], Area: locArea, Aisle: ppaisle, Row: pprow, Shelf: ppshelf, Bin: ppbin
        });
    }
    /***
     * BTB_PC_18 - Deepthi N H
     * */
    selectAreaChange = (e) => {
        //debugger
        let area = e;
        let Aisledd = [];
        this.state.DestLocGrid.map((item, index) => {
            if (item.STORAGE_AREA == e.value && Aisledd.indexOf(item.STOR_LEVEL_1) == -1) {
                let obj = {
                    value: item.STOR_LEVEL_1,
                    label: item.STOR_LEVEL_1
                }
                Aisledd.push(obj);
            }
        })
        let pp = Aisledd.filter((ele, ind) => ind === Aisledd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        pp.sort((a, b) => a.label > b.label ? 1 : -1);
        this.setState({ Aisle: pp, SelectedDestArea: e, SelectedDestAisle: {}, SelectedDestRow: {}, SelectedDestShelf: {}, SelectedDestBin: {}, Row: [], Bin: [], Shelf: [] });
    }
    /***
     * BTB_PC_19 - Deepthi N H
     * */
    //This method is invoked when user selects Aisle DropDown 
    selectAisleChange = (e) => {
        //debugger
        let aisle = e;
        let Rowdd = [];
        this.state.DestLocGrid.map((item, index) => {
            if (item.STORAGE_AREA == this.state.SelectedDestArea.value && item.STOR_LEVEL_1 == e.value
                && Rowdd.indexOf(item.STOR_LEVEL_2) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_2,
                    label: item.STOR_LEVEL_2
                }
                Rowdd.push(obj);
            }
        })
        let pp = Rowdd.filter((ele, ind) => ind === Rowdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label))
        pp.sort((a, b) => a.label > b.label ? 1 : -1);
        /*[07/20/22,BUG:2373-Bin and Shelf dropdown should be cleared in the onchange of Asile], Priyanka D */
        this.setState({ Row: pp, SelectedDestAisle: e, SelectedDestRow: {}, SelectedDestShelf: {}, SelectedDestBin: {}, Shelf: [], Bin: [] })
    }
    /***
     * BTB_PC_20 - Deepthi N H
     * */
    //This method is invoked when user selects Row DropDown 
    selectRowChange = (e) => {

        let row = e;
        let Shelfdd = [];
        this.state.DestLocGrid.map((item, index) => {
            if (item.STORAGE_AREA == this.state.SelectedDestArea.value && item.STOR_LEVEL_1 == this.state.SelectedDestAisle.value
                && item.STOR_LEVEL_2 == e.value && Shelfdd.indexOf(item.STOR_LEVEL_3) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_3,
                    label: item.STOR_LEVEL_3
                }
                Shelfdd.push(obj);
            }
        })
        let pp = Shelfdd.filter((ele, ind) => ind === Shelfdd.findIndex(elem => elem.value === ele.value && elem.label === ele.label));
        pp.sort((a, b) => a.label > b.label ? 1 : -1);
        /*[07/20/22,BUG:2373-Bin  should be cleared in the onchange of Row], Priyanka D */
        this.setState({ Shelf: pp, SelectedDestRow: e, SelectedDestShelf: {}, SelectedDestBin: {}, Bin: [] })
    }
    /***
     * BTB_PC_21 - Deepthi N H
     * */
    //This method is invoked when user selects Shelf DropDown 
    selectShelfChange = (e) => {

        let shelf = e;
        let Bindd = [];
        this.state.DestLocGrid.map((item, index) => {
            if (item.STORAGE_AREA == this.state.SelectedDestArea.value && item.STOR_LEVEL_1 == this.state.SelectedDestAisle.value
                && item.STOR_LEVEL_3 == e.value && item.STOR_LEVEL_2 == this.state.SelectedDestRow.value && Bindd.indexOf(item.STOR_LEVEL_4) == -1
            ) {
                let obj = {
                    value: item.STOR_LEVEL_4,
                    label: item.STOR_LEVEL_4
                }
                Bindd.push(obj);
            }
        })
        let pp = Bindd.filter((ele, ind) => ind === Bindd.findIndex(elem => elem.value === ele.value && elem.label === ele.label));
        pp.sort((a, b) => a.label > b.label ? 1 : -1);
        this.setState({ Bin: pp, SelectedDestShelf: e, SelectedDestBin: {} })
    }
    /***
     * BTB_PC_22 - Deepthi N H
     * */
    //This method is invoked when user selects Bin DropDown 
    selectBinChange = (e) => {

        let bin = e;
        this.setState({ SelectedDestBin: e })
    }
    /***
     * BTB_PC_25 - Deepthi N H
     * */
    SubmitClick = () => {
        //bug - 2571 - Functional issue in Bin to Bin Transfer - Dhamotharan P

        if (this.state.ItemID == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter item ID to tranfer location'
            });
            // alert('Please Enter Item ID To Tranfer Location');
            return;
        }
        else if (this.state.OrigLocGrid.length < 1 || this.state.DestLocGrid.length < 1) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter valid item ID'
            });
            // alert('Please Enter Valid Item ID');
            return;
        }
        else if (this.state.TransQuantity == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter quantity to adjust'
            });
            // alert('Please Enter Quantity To Adjust');
            return;
        }
        else if (parseInt(this.state.TransQuantity) <= 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Transfer quantity must be greater than zero'
            });
            return;
        }
        else if (this.IsDifferentToFromLocation() == false) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Original and destination locations must be different.'
            });
            // alert('Original and Destination locations must be different.');
            return;
        }
        else if (this.IsValidToSubmit() == false) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Quantity to transfer must not be greater than available quantity.'
            });
            //  alert('Quantity to transfer must not be greater than available quantity.');
            return;
        }
        else if (this.state.SelectedDestAisle.value == "" || this.state.SelectedDestAisle.value == null) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select destination aisle'
            });
            // alert('Please Select Destination Aisle');
            return;
        }
        else if (this.state.SelectedDestRow.value == "" || this.state.SelectedDestRow.value == null) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select destination row'
            });
            // alert('Please Select Destination Row');
            return;
        }
        else if (this.state.SelectedDestShelf.value == "" || this.state.SelectedDestShelf.value == null) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select destination shelf'
            });
            //alert('Please Select Destination Shelf');
            return;
        }
        else if (this.state.SelectedDestBin.value == "" || this.state.SelectedDestBin.value == null) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please select destination bin'
            });
            // alert('Please Select Destination Bin');
            return;
        }
        else {
            $('#TransferConfPopUp').modal('show');
        }
    }
    /***
     * BTB_PC_23 - Deepthi N H
     * */
    IsDifferentToFromLocation = () => {
        if (this.state.SelectedOrigArea == this.state.SelectedDestArea.label && this.state.SelectedOrigAisle == this.state.SelectedDestAisle.label
            && this.state.SelectedOrigRow == this.state.SelectedDestRow.label && this.state.SelectedOrigShelf == this.state.SelectedDestShelf.label && this.state.SelectedOrigBin == this.state.SelectedDestBin.label) {
            return false;
        }
        else {
            return true;
        }
    }
    /***
     * BTB_PC_24 - Deepthi N H
     * */
    IsValidToSubmit = () => {
        if (parseInt(this.state.TransQuantity) > parseInt(this.state.SelectedCurQty)) {
            return false;
        }
        else {
            return true;
        }
    }
    BindGridData = () => {

        if (this.state.OrigLocGrid.length > 0) {
            return this.state.OrigLocGrid.map((value, index) => {
                return (<React.Fragment key={index}>{value.INV_ITEM_ID != "" ? <>
                    <tr>
                        <td>
                            <label className="custom-radiobtn">
                                <input type="radio" name="BURad" id="BURad" checked={value.IsLocSelected} onClick={e => this.OnHandleGridRadChange(e, index)} />
                                <span className="checkmark checkmark-org" />
                            </label>
                        </td>
                        <td>{`${value.BUSINESS_UNIT}-${value.DESCR}`}</td>
                        <td>{value.QuantityAvail}</td>
                        <td>{value.SERIAL_ID}</td>
                        <td>{value.STORAGE_AREA}</td>
                        <td>{value.STOR_LEVEL_1}</td>
                        <td>{value.STOR_LEVEL_2}</td>
                        <td>{value.STOR_LEVEL_3}</td>
                        <td>{value.STOR_LEVEL_4}</td>
                    </tr>
                </> : null}
                </React.Fragment>

                );


            })

        }
    }
    /***
     * BTB_PC_26 - Deepthi N H
     * */
    TransferConfClick = () => {
        let TransConfSubmitBO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
            SelectedBU: this.state.SelectedOrigBU,
            ItemID: this.state.ItemID.toUpperCase(),
            IsMakeDef: this.state.MakeDefchk,
            SerialId: this.state.SerialId,
            SelOrigArea: this.state.SelectedOrigArea,
            SelOrigAisle: this.state.SelectedOrigAisle,
            SelOrigRow: this.state.SelectedOrigRow,
            SelOrigShelf: this.state.SelectedOrigShelf,
            SelOrigBin: this.state.SelectedOrigBin,
            SelDestArea: this.state.SelectedDestArea.value,
            SelDestAisle: this.state.SelectedDestAisle.value,
            SelDestRow: this.state.SelectedDestRow.value,
            SelDestShelf: this.state.SelectedDestShelf.value,
            SelDestBin: this.state.SelectedDestBin.value,
            TransferQty: this.state.TransQuantity,
            Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID")

        }
        $('#TransferConfPopUp').modal('hide');
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        BinToBinAction.TransfConfSubmit(TransConfSubmitBO)
    }
    /***
     * BTB_PC_28 - Deepthi N H
     * */
    TransferConfClickResponse = () => {

        let TransferConfSubmitRes = JSON.parse(BinToBinStore.TransferResData);
        //WBW-19 Bin-to-Bin Transfer Bugs-Deepthi
        if (TransferConfSubmitRes.includes("SUCCESS")) {
            $('#ItemID').val("");
            this.setState({ OrigLocGrid: [], DestLocGrid: [], ItemID: "", IsMakeDef: false, ItemDescription: "", TransQuantity: "", TransferMessage: TransferConfSubmitRes });
        }
        else {
            this.setState({ TransferMessage: TransferConfSubmitRes });
        }
        $('#successpopup').modal('show');
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /***
     * BTB_PC_29 - Deepthi N H
     * */
    OkBtnClick = () => {
        if (this.state.TransferMessage.includes("SUCCESS")) {
            this.setState({ OrigLocGrid: [], DestLocGrid: [], ItemID: "", IsMakeDef: false, ItemDescription: "", TransQuantity: "" });
        }
    }

    clearItemId = () => {
        this.setState({ ItemID: "" });
    }
    keyPress = (e) => {
        if (e.keyCode == 13) {
            { this.SearchItemClick(e) };
        }
    }
    //To handle the favorite page
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Bin To Bin Transfer",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            BinToBinAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            BinToBinAction.deleteFavPage(deleteFavPageBO)
        }
    };
    loadFavPageResponse = () => {
        if (this.state.truckUser == "False") {
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        let favPageResponse = JSON.parse(BinToBinStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (BinToBinStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(BinToBinStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(BinToBinStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // this.refreshMenu();
    };
    navigateToFieldInventory = () => {
        this.props.history.push('/FieldInventoryWorkbench');
    };
    handleQtyChange = (operation, event, index) => {
        let checkedItems = [...this.state.checkedItems]; // Create a copy of checkedItems
        let currentQty = checkedItems[index].QUANTITY ; // Get the current quantity for the specific item
        let avialQuantity = checkedItems[index].actual_qty;
        let quantityErrors = [...this.state.quantityErrors];
        if (operation === 'increment' ) {
            checkedItems[index].QUANTITY = currentQty ? currentQty + 1 : 1; // Increment quantity
            quantityErrors[index] = false; 
        } else if (operation === 'decrement' ) {
            checkedItems[index].QUANTITY = currentQty-1 ; // Decrement quantity
            quantityErrors[index] = false;
        } else if (operation === 'text') {
            let enteredQuantity = event.target.value;
            if (/^\d*$/.test(enteredQuantity)) {
                if (enteredQuantity === '' || enteredQuantity === "0") {
                    checkedItems[index].QUANTITY = ''
                } else if (  parseInt(enteredQuantity) <= avialQuantity) {
                    checkedItems[index].QUANTITY = parseInt(enteredQuantity);
                    quantityErrors[index] = false;
                } 
            }
        }

        this.setState({ checkedItems, qtyitemmsg: '', quantityErrors: quantityErrors ? quantityErrors:[] }); // Update state with modified checked items
    };
    handleBinToBinYes = () => {
        DeleteFlag = true;
        proceed = false;
        $('#bintobinmixedcart').modal('hide');
        this.handleSave();
    }

    handleBinToBinNo = () => {
        DeleteFlag = false;
        proceed = true;
        $('#bintobinmixedcart').modal('hide');
        this.setState({ itemDetailShow: false });
    }
    handleSave = () => {
        const { TruckidValue, TechNameValue, TruckFieldQty, UserId, CartData, checkedItems } = this.state;  
        
        // Check if item is already in the cart
        let itemAlreadyInCart  = checkedItems.some(checkedItem =>
            CartData.some(cartItem =>
                cartItem.ITEM_ID === checkedItem.inv_item_id &&
                cartItem.DESCR254 === checkedItem.short_desc &&
                cartItem.STORAGE_AREA === checkedItem.isa_truck_id
            )
        );

        if (itemAlreadyInCart) {
            $('#bintobinitemalready').modal('show');
            this.setState({ itemDetailShow: false });
            return;
        } else {
            // Reset quantity errors
            let quantityErrors = new Array(this.state.checkedItems.length).fill(false); // Initialize all as false

            // Validate quantities
            let hasError = false;
            this.state.checkedItems.forEach((item, index) => {
                if (this.state.checkedItems[index].QUANTITY > item.actual_qty || this.state.checkedItems[index].QUANTITY ==='') {
                    hasError = true;
                    quantityErrors[index] = true; // Mark this index as having an error
                }
            });

            if (hasError) {
                this.setState({ quantityErrors, qtyitemmsg: 'Please enter a valid quantity.'  }); // Update state with errors
                return; // Stop further execution
            }
            if (CartData.length > 0) {
                const differentTruckId = checkedItems[0].isa_truck_id !== CartData[0].STORAGE_AREA;
                if (differentTruckId && proceed) {
                    $('#bintobinmixedcart').modal('show');
                    return;
                }
            }

            const insertStockData = {
                ENTERED_BY: CookieService.getLocalStorageValues("Session_UserID"),
                UserBU: (CookieService.getLocalStorageValues("Session_AGENTUSERBU") === "" ? CookieService.getLocalStorageValues("Session_BUSUNIT") : CookieService.getLocalStorageValues("Session_AGENTUSERBU")),
                FromWeb: true,
                DeleteFlag: DeleteFlag ? "true" : "false",
                Items: this.state.checkedItems.map(item => ({
                    TruckID: item.isa_truck_id,
                    UserID:item.employee_id,
                    ShipTo: item.isa_truck_id,
                    ItemID: item.inv_item_id,
                    Desc: item.short_desc,
                    SerialID: item.serial_id,
                    Quantity: item.QUANTITY,
                    MFG: item.mfg_std,
                    MFGID: item.manufacturer_part_number,
                    UOM: item.uom,
                    Image_URL: item.image_list ,
                    VendorID: item.vendor_id ,
                }))
            };

            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            BinToBinAction.insertTransferAction(insertStockData);
        }
    };
    insertTransferActionResponse = () => {
        let response = JSON.parse(BinToBinStore.insertTransferAction);
        let CartData = [];
        DeleteFlag = false;
        proceed = true;
        let pageCount = 0
        if (response === "Technical issue") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue. Please contact SDI Customer Care"
            });
        } else {

            CartData = response;
            pageCount = parseFloat(CartData.length) / 10
            this.props.toastSuccessMessage("Item successfully added to cart")



        }
        this.setState({ CartData, itemDetailShow: false, pageCount })

        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }
    bindCartData = () => {
        const { CartData, PageNo } = this.state;

        if (CartData && CartData.length > 0) {
            const startIndex = (PageNo - 1) * 10;
            const endIndex = startIndex + 10;
            const paginatedData = CartData.slice(startIndex, endIndex);

            if (paginatedData.length > 0) {
                return paginatedData.map((val, index) => (
                    <tr key={index}>
                        <td>{val.ITEM_ID}</td>
                        <td>{val.DESCR254}</td>
                        <td>{val.UOM}</td>
                        <td>{val.SERIAL_ID}</td>
                        <td className="text-end">{val.QUANTITY}</td>
                        <td className="text-center text-nowrap">
                            <a onClick={() => this.editItem(val)}><img className="mr-3" src="images/edit-icon.svg" alt="edit" /></a>
                            <a onClick={() => this.showDeleteConfirmation(val, false)}><img src="images/Cross.svg" alt="delete" /></a>
                        </td>
                    </tr>
                ));
            }
        } else {
            return (
                <div className="pt-2">
                    <div className="col-md-12 p-2 p-0 accept-transfer-container">
                        <div className="no-record-found-section">
                            <img src="Images/no-record-found.png" alt="select-file-to-view-img" className="no-record-found" />
                            <p className="font-14 mt-4 text-label-color custom-select-records">You have no items added to the transfer cart</p>
                        </div>
                    </div>
                </div>
            );
        }
    };
    editItem = (item) => {
        const deepCopiedItem = JSON.parse(JSON.stringify(item));
        this.setState({
            TransferEditPopUp: deepCopiedItem
        });
        $(`#TransferEditPopUp`).modal({
            backdrop: 'static',
            keyboard: false
        });
    };
    handleEditQtyChange = (operation,event) => {
        let TransferEditPopUp = JSON.parse(JSON.stringify(this.state.TransferEditPopUp));
        let enteredQuantity=0;
        if (operation === 'increment' && TransferEditPopUp && TransferEditPopUp.QUANTITY <= TransferEditPopUp.QtyAvailable) {
            TransferEditPopUp.QUANTITY += 1;
        } else if (operation === 'decrement' && TransferEditPopUp && TransferEditPopUp.QUANTITY >= 1) {
            TransferEditPopUp.QUANTITY -= 1;
        } else if (operation === 'text') {
            enteredQuantity = event.target.value;
            if (/^\d*$/.test(enteredQuantity)) {
                // Convert to number for comparison
                const quantityNumber = enteredQuantity === '' ? '': parseInt(enteredQuantity);


                TransferEditPopUp.QUANTITY = quantityNumber; // Set valid quantity

            }

        }

        this.setState({
            TransferEditPopUp, qtymsg:''
        });
    }


    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ PageNo: pageNo });
    };
    UpdateTransferAction = () => {
        const { TransferEditPopUp } = this.state;
        if (TransferEditPopUp.QUANTITY > TransferEditPopUp.QtyAvailable || TransferEditPopUp.QUANTITY < 1) {

            if (TransferEditPopUp.QUANTITY === '' || TransferEditPopUp.QUANTITY === 0) {
                this.setState({ qtymsg: 'Please enter a valid quantity.' });
                return
            } else {
                this.setState({ qtymsg: 'The quantity should be less than or equal to the available quantity.' });
                return
            }

        }
        let updateTransferActionBO = {
            ShipTo: CookieService.getLocalStorageValues("Session_TRUCK_USER") ? (CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : (CookieService.getLocalStorageValues("HOME_STORE") ? CookieService.getLocalStorageValues("HOME_STORE") : " "),
            UserID: CookieService.getLocalStorageValues("Session_UserID"),
            ItemID: TransferEditPopUp.ITEM_ID,
            Quantity: TransferEditPopUp.QUANTITY,
            DeleteFlag: "update"
        };

        $('#TransferEditPopUp').modal('hide');
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        BinToBinAction.updateTransferAction(updateTransferActionBO);
    };
    updateTransferActionResponse = () => {
        let response = JSON.parse(BinToBinStore.updateTransferAction);

        if (response === "Technical issue") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue. Please contact SDI Customer Care"
            });
        } else {
            let CartData = response.TransferItems;
            let pageCount = parseFloat(CartData.length) / 10
            this.setState({ CartData, pageCount });
        }

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    showDeleteConfirmation = (item, flag) => {
        const message = flag ? "Are you sure you want to cancel the items?" : "Do you want to remove this item?";
        this.setState({
            itemToDelete: item,
            deleteFlag: flag,
            confirmationMessage: message
        });
        $('#deleteConfirmationPopup').modal('show');
    }
    handleDeleteItem = (confirm) => {
        const { itemToDelete, deleteFlag } = this.state;

        if (confirm) {
            let deleteBO = {
                ShipTo: CookieService.getLocalStorageValues("Session_TRUCK_USER") ? (CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : (CookieService.getLocalStorageValues("HOME_STORE") ? CookieService.getLocalStorageValues("HOME_STORE") : " "),
                UserID: CookieService.getLocalStorageValues("Session_UserID"),
                ItemID: itemToDelete.ITEM_ID,
                Quantity: itemToDelete.QUANTITY,
                DeleteFlag: deleteFlag ? "true" : "false"
            };
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            BinToBinAction.updateTransferAction(deleteBO);
        }

        this.setState({ itemToDelete: null, deleteFlag: false, confirmationMessage: '' });
        $('#deleteConfirmationPopup').modal('hide');
    }
    NAItems = () => {
        if (!this.state.unavailableItems || this.state.unavailableItems.length === 0) {
            return null;
        }

        return this.state.unavailableItems.map((item, index) => (
            <div key={index}>
                <p>{item.ItemId} - {item.DESCR254}</p>
            </div>
        ));
    }
    QTYNA = (action) => {
        if (action === "1") {
            // Remove these items
            let UnAvaialableList = this.state.unavailableItems.map(item => item.ITEM_ID);
            if (!UnAvaialableList) {
                return
            }
            let DeleteUnAvailableObj = {
                UserID: CookieService.getLocalStorageValues("Session_UserID"),
                ShipTo: CookieService.getLocalStorageValues("Session_TRUCK_USER") ? (CookieService.getLocalStorageValues("Session_TRUCK_STORAGE_AREA")) : (CookieService.getLocalStorageValues("HOME_STORE") ? CookieService.getLocalStorageValues("HOME_STORE") : " "),
                UnAvailableList: UnAvaialableList
            };
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            BinToBinAction.DeleteUnavailableItems(DeleteUnAvailableObj);
        } else if (action === "2") {
            // Apply Change
            $('#QTY-popupbintobin').modal('hide');
        }
    }
    handleSort = (event) => {
        const columns = document.querySelectorAll('.table-sort .sort-icon');
        const clickedColumn = event.currentTarget.querySelector('.sort-icon');
        columns.forEach(column => {
            if (column !== clickedColumn) {
                column.classList.remove('desc');
                column.classList.add('asc');
            }
        });

        let sortValue = "";
        let sortColumn = event.target.id;
        if (clickedColumn.classList.contains('asc')) {
            clickedColumn.classList.remove('asc');
            clickedColumn.classList.add('desc');
            sortValue = 'DESC';
        } else {
            clickedColumn.classList.remove('desc');
            clickedColumn.classList.add('asc');
            sortValue = 'ASC';
        }

        this.sort(sortColumn, sortValue);
    }

    sort = (Column, Type) => {
        const orderedFilteredData = [...this.state.CartData];
        const compareAsc = (a, b) => (a[Column] > b[Column]) ? 1 : ((a[Column] < b[Column]) ? -1 : 0);
        const compareDesc = (a, b) => (a[Column] < b[Column]) ? 1 : ((a[Column] > b[Column]) ? -1 : 0);
        const sortedArr = orderedFilteredData.sort(Type === "ASC" ? compareAsc : compareDesc);

        this.setState({ CartData: sortedArr });
    }

    TransferSubmitClick = () => {
        let unavailableItems = [];
        this.state.CartData.forEach(item => {
            if (item.IsQtyAvailable === true) {
                unavailableItems.push(item);
            }
        });

        if (unavailableItems.length > 0) {
            $('#QTY-popupbintobin').modal('show');
            return;
        }



        let transferSubmitBO = {
            UserID: CookieService.getLocalStorageValues("Session_UserID"),
            UserBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            UserLocation: this.state.CartData[0].STORAGE_AREA,
            TransferEmployee: this.state.UserId,
            TransferLocation: this.state.TruckidValue.value,
            ShipTo: this.state.CartData[0].STORAGE_AREA
        };

        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        BinToBinAction.TruckTransferSubmit(transferSubmitBO);

    }

    TruckTransferSubmitResponse = () => {
        let TransferConfSubmitRes = BinToBinStore.TruckTransferSubmit;

        if (TransferConfSubmitRes === "Technical issue") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Technical Issue. Please contact SDI Customer Care"
            });
        } else {
            this.setState({ orderNumber: TransferConfSubmitRes });
        }

        $('#successpopup').modal('show');
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    renderCheckedItems = () => {
        const { checkedItems, quantityErrors } = this.state;

        if (checkedItems.length > 0) {
            return (
                <div className="col-md-12 py-3 ">
                    {checkedItems.map((item, index) => (
                        <div className="row d-flex align-items-center justify-content-between border-bottom w-100" key={index}>
                            <div className="col-12 d-flex align-items-center justify-content-between flex-wrap p-0">
                                <div className="bin-transfer-alignments p-0">
                                    <div className="mb-2">
                                        <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                            Item ID: <span className="app-enhancements-sub-content ml-3">{item.inv_item_id}</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="bin-transfer-alignments p-0" style={{"width": "330px"}}>
                                    <div className="mb-2">
                                        <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                            Description: <span className="app-enhancements-sub-content ml-3">{item.short_desc}</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="bin-transfer-alignments p-0">
                                    <div className="mb-2">
                                        <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                            Serial ID: <span className="app-enhancements-sub-content ml-3">{item.serial_id || 'N/A'}</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="bin-transfer-alignments p-0">
                                    <div className="mb-2">
                                        <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                            UOM: <span className="app-enhancements-sub-content ml-3">{item.uom}</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="bin-transfer-alignments p-0">
                                    <div className="mb-2">
                                        <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                            QTY available: <span className="app-enhancements-sub-content ml-3">{item.actual_qty}</span>
                                        </p>
                                    </div>
                                </div>
                                <div className="bin-transfer-alignments p-0">
                                    <div className="custom-product-add-cart justify-content-start p-0 mb-2">
                                        <p className="font-14 app-enhancements-main-content mb-0 text-wrap">Quantity to transfer</p>
                                        <form id={`quantity-form-${index}`} method="POST" className={`quantity font-12 border ${quantityErrors[index] ? 'required' : ''}`} action="#">
                                            <input type="button" value="-" className="qtyminus noborderbin minus" onClick={(e) => this.handleQtyChange('decrement', e, index)} disabled={item.QUANTITY <= 1 || item.QUANTITY===''} />
                                            <input
                                                type="text"
                                                name={`quantity-${index}`}
                                                maxLength="5"
                                                value={item.QUANTITY}
                                                onChange={(e) => this.handleQtyChange('text', e, index)}
                                                className="qty noborderbin" // Add 'is-invalid' class if there's an error
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                style={{ outline: "0px !important" }}
                                            />
                                            <input type="button" value="+" className="qtyplus noborderbin plus" onClick={(e) => this.handleQtyChange('increment', e, index)} disabled={item.QUANTITY >= item.actual_qty} />
                                        </form>
                                        <div class="col bin-transfer-alignments p-0 float-end d-flex justify-content-end quantity-cancel-btn">
                                            <div class="mb-2 float-end d-md-block d-sm-flex d-flex align-items-center">
                                                <p class="font-14 app-enhancements-main-content mb-0 text-wrap d-md-none d-sm-block mr-4 ml-5">Remove item:
                                                        </p>
                                                <button class="bg-white border rounded-2 py-1 px-2" onClick={() => this.RemoveItemDetails(index)}>
                                                    <img class="" src="images/Cross.svg"  alt="edit"/>
                                                </button>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            );
        } 
    }

    RemoveItemDetails = (index) => {
        const { checkedItems, CartData } = this.state;

        if (index === "itemsalreadymap") {
            // Display items that are already in the cart
            const WNA = checkedItems.filter(item =>
                CartData.some(cartItem => cartItem.ITEM_ID === item.inv_item_id)
            );

            if (WNA && WNA.length > 0) {
                return (
                    <ul className="row" style={{ marginLeft: '32px', padding: 0, listStyleType: 'none' }}>
                        {WNA.map((val, ind) => (
                            <li className="col-6" style={{ display: 'flex', alignItems: 'center', fontSize: '15px', marginBottom: '10px' }} key={ind}>
                                <span style={{ fontSize: '24px', left: '50px', lineHeight: '0.9' }}>•&nbsp;</span>
                                <span style={{ marginLeft: '5px' }}>
                                    {val.inv_item_id}
                                </span>
                            </li>
                        ))}
                    </ul>
                );
            }
        } else if (index === "removeitemsalready") {
            // Remove items that are already in the cart from checkedItems
            const updatedCheckedItems = checkedItems.filter(item =>
                !CartData.some(cartItem => cartItem.ITEM_ID === item.inv_item_id)
            );
            $('#bintobinitemalready').modal('hide');
            if (updatedCheckedItems.length > 0) {
                this.setState({ checkedItems: updatedCheckedItems }, () => {
                    this.handleSave();
                });
            } else {
                this.setState({ checkedItems: [], itemDetailShow: false})
            }
            
        } else {
            // Handle other cases if needed
            // Remove a specific item based on the index passed
            const updatedCheckedItems = this.state.checkedItems.filter((v, i) => i !== index);
            let hasError = false;
            let quantityErrors = new Array(updatedCheckedItems.length).fill(false);
            updatedCheckedItems.forEach((item, index) => {
                if (updatedCheckedItems[index].QUANTITY > item.actual_qty || updatedCheckedItems[index].QUANTITY==='' ) {
                    hasError = true;
                    quantityErrors[index] = true; // Mark this index as having an error
                }
            });
            this.setState({ checkedItems: updatedCheckedItems, quantityErrors, qtyitemmsg: hasError ? 'Please enter a valid quantity.' : '', itemDetailShow: updatedCheckedItems.length>0?true:false });
        }
    }
    /***
     * BTB_PC_7 - Deepthi N H
     * */
    render() {
        return (
            //<div className="container-fluid content-section">

            <div className="container-fluid content-section bin-transfer-container">
                <div className="row">
                    <div className="container-fluid content-margin">
                        <div className="col-md-12 page-heading mb-3 float-left p-0">
                            <h5 className="page-title">{this.state.isFromFieldInventory ? (
                                <span className="table-sort mr-2" onClick={this.navigateToFieldInventory}>
                                    <img src="images/left-arrow.svg" alt="sort-up" />
                                </span>
                            ) : null}

                                Bin To Bin Transfer</h5>
                            <div className="fav-item-maintenance-icon mt-1">
                                <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                <label htmlFor="checkbox-OrdStatus">
                                    <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                        <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                            <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                            <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                            <g className="grp7" opacity={0} transform="translate(7 6)">
                                                <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                            </g>
                                            <g className="grp6" opacity={0} transform="translate(0 28)">
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                            </g>
                                            <g className="grp3" opacity={0} transform="translate(52 28)">
                                                <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                            </g>
                                            <g className="grp2" opacity={0} transform="translate(44 6)">
                                                <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp5" opacity={0} transform="translate(14 50)">
                                                <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp4" opacity={0} transform="translate(35 50)">
                                                <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                            </g>
                                            <g className="grp1" opacity={0} transform="translate(24)">
                                                <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                            </g>
                                        </g>
                                    </svg>
                                </label>
                            </div>
                        </div>
                        {this.state.truckUser == "False" ?
                            (<>
                                <div className="col-md-12 float-left  mb-3" style={{ "padding-left": '2px' }} >
                                    <div className="row ">
                                        <div className="col-md-12 p-0 float-left mb-4">
                                            <div className="row">
                                                <div className="col-md-3 my-2">
                                                    <div className="row">
                                                        {/* bug - 2569 UI issue in Bin to Bin transfer - Dhamotharan P*/}
                                                        <label className="catalog-label col-md-4 float-left mt-2">Item ID</label>
                                                        <div className="col-md-8">
                                                            <input type="text" id="ItemID" name="ItemID" className="form-control float-left" maxLength="10" onKeyDown={this.keyPress} value={this.state.ItemID} onChange={(e) => this.OnHandleChange(e, "ItemID")} />
                                                            <span className={this.state.ItemID != null && this.state.ItemID != "" && this.state.ItemID != " " ? "search-cancel-header cursor-pointer" : "d-none"} style={{ "right": "20px" }} onClick={() => this.clearItemId()}></span>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="col-md-4 col-lg-4 my-2 pl-3 ml-1">
                                                    <button className="btn btn-primary custom-btn-primary primary-btn float-left" onClick={e => this.SearchItemClick(e)}>Search</button>
                                                </div>
                                                {this.state.ItemDescription != "" ?
                                                    <div className="col-md-12 item-details-value my-2">
                                                        <label>{this.state.ItemDescription}</label>
                                                    </div> : null}
                                                {this.state.PhyInvMsg != "" ?
                                                    <div className="col-md-12 item-details-value my-2" style={{ "color": "red" }}>
                                                        <label>{this.state.PhyInvMsg} </label>
                                                    </div> : null}
                                            </div>
                                        </div>
                                        {/*Item Info starts here*/}
                                        {this.state.OrigLocGrid.length > 0 ?
                                            <div className="col-md-12 float-left mb-4 p-0">
                                                <h5 className="fav-item-title mb-2">Default Location</h5>

                                                <div className="row">
                                                    <div className="col-auto mb-3">
                                                        <label className="catalog-label w-100">BU </label>
                                                        <label className="item-details-value  w-100">{this.state.ItemDefBUName}</label>
                                                    </div>
                                                    <div className="col-auto mb-3">
                                                        <label className="catalog-label w-100">Area </label>
                                                        <label className="item-details-value  w-100">{this.state.ItemDefArea}</label>
                                                    </div>
                                                    <div className="col-auto mb-3">
                                                        <label className="catalog-label w-100">Aisle </label>
                                                        <label className="item-details-value  w-100">{this.state.ItemDefAisle}</label>
                                                    </div>
                                                    <div className="col-auto mb-3">
                                                        <label className="catalog-label w-100">Row </label>
                                                        <label className="item-details-value  w-100">{this.state.ItemDefRow}</label>
                                                    </div>
                                                    <div className="col-auto mb-3">
                                                        <label className="catalog-label w-100">Shelf </label>
                                                        <label className="item-details-value  w-100">{this.state.ItemDefShelf}</label>
                                                    </div>
                                                    <div className="col-auto mb-3">
                                                        <label className="catalog-label w-100">Bin </label>
                                                        <label className="item-details-value  w-100">{this.state.ItemDefBin}</label>
                                                    </div>
                                                </div>
                                                <h5 className="fav-item-title mb-2">Current Location</h5>
                                                <div className="table-responsive">
                                                    <table className="table ZEUS_Grid FOM-grid mobileflex-grid">
                                                        <thead>
                                                            <tr>
                                                                <th />
                                                                <th>BU</th>
                                                                <th>Quantity</th>
                                                                <th>Serial ID</th>
                                                                <th>Area</th>
                                                                <th>Aisle</th>
                                                                <th>Row</th>
                                                                <th>Shelf</th>
                                                                <th>Bin</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.BindGridData()}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div> : null}
                                        {this.state.DestLocGrid.length > 0 ? < div class="col-md-12 float-left mb-4 p-0">
                                            <div class="table-responsive table-customstyle-whitespace mt-3" style={{ "marginBottom": "10%", "height": "150%", "overflow": "hidden" }}>
                                                <h5 className="fav-item-title mb-2">Destination Location</h5>
                                                {/*WW-396 Bin-To-Bin transfer page Default Location is showing the PHYSICAL_INV location; needs to show DEFAULT_LOC_INV location - Deepthi*/}
                                                {/*<div className="row">
                                            <div className="col-auto mb-3">
                                                <label className="catalog-label w-100">Selected</label>
                                                <label className="catalog-label w-100">Destination</label>
                                            </div>
                                            <div className="col-auto mb-3">
                                                <label className="catalog-label w-100">BU </label>
                                                <label className="item-details-value  w-100">{`${this.state.SelectedOrigBU}-${this.state.SelectedBuName}`}</label>
                                            </div>
                                            <div className="col-auto mb-3">
                                                <label className="catalog-label w-100">Area </label>
                                                <label className="item-details-value  w-100">{this.state.SelectedDestArea.value}</label>
                                            </div>
                                            <div className="col-auto mb-3">
                                                <label className="catalog-label w-100">Aisle </label>
                                                <label className="item-details-value  w-100">{this.state.SelectedDestAisle.value}</label>
                                            </div>
                                            <div className="col-auto mb-3">
                                                <label className="catalog-label w-100">Row </label>
                                                <label className="item-details-value  w-100">{this.state.SelectedDestRow.value}</label>
                                            </div>
                                            <div className="col-auto mb-3">
                                                <label className="catalog-label w-100">Shelf </label>
                                                <label className="item-details-value  w-100">{this.state.SelectedDestShelf.value}</label>
                                            </div>
                                            <div className="col-auto mb-3">
                                                <label className="catalog-label w-100">Bin </label>
                                                <label className="item-details-value  w-100">{this.state.SelectedDestBin.value}</label>
                                            </div>
                                        </div>*/}
                                                <table class="table ZEUS_Grid FOM-grid mobileflex-grid" id="table">
                                                    <thead>
                                                        <tr>
                                                            <th>Area</th>
                                                            <th>Aisle</th>
                                                            <th>Row</th>
                                                            <th>Shelf</th>
                                                            <th>Bin</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>

                                                            <td data-label="Area" style={{ "max-width": "80px" }}>
                                                                <Select class="form-control"
                                                                    id="AreaDD"
                                                                    name="Area"
                                                                    options={this.state.Area}
                                                                    value={this.state.SelectedDestArea}
                                                                    onChange={(e) => this.selectAreaChange(e)}
                                                                />
                                                            </td>
                                                            <td data-label="AIS" style={{ "max-width": "80px" }}>
                                                                <Select class="form-control"
                                                                    id="AisleDD"
                                                                    name="Aisle"
                                                                    options={this.state.Aisle}
                                                                    value={this.state.SelectedDestAisle}
                                                                    onChange={(e) => this.selectAisleChange(e)}
                                                                />
                                                            </td>
                                                            <td data-label="Row" style={{ "max-width": "80px" }}>
                                                                <Select class="form-control"
                                                                    id="RowDD"
                                                                    name="Row"
                                                                    options={this.state.Row}
                                                                    value={this.state.SelectedDestRow}
                                                                    onChange={(e) => this.selectRowChange(e)}
                                                                />
                                                            </td>
                                                            <td data-label="SHF" style={{ "max-width": "80px" }}>
                                                                <Select class="form-control"
                                                                    id="ShelfDD"
                                                                    name="Shelf"
                                                                    options={this.state.Shelf}
                                                                    value={this.state.SelectedDestShelf}
                                                                    onChange={(e) => this.selectShelfChange(e)}
                                                                />
                                                            </td>
                                                            <td data-label="BIN" style={{ "max-width": "80px" }}> <Select class="form-control"
                                                                id="BinDD"
                                                                name="Bin"
                                                                options={this.state.Bin}
                                                                value={this.state.SelectedDestBin}
                                                                onChange={(e) => this.selectBinChange(e)}
                                                            />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="col-md-9 float-left mb-2">
                                                    <div className="row">

                                                        <label className="catalog-label col-md-2 px-1" htmlFor="AdjustQuantity">Transfer Quantity</label>
                                                        <div className="col-md-4">
                                                            <div className="row align-items-center">
                                                                <input type="text" className="form-control float-left" id="TransQuantity" name="TransQuantity" value={this.state.TransQuantity} onChange={(e) => this.OnHandleChange(e, "TransQuantity")} />
                                                                <div className="custom-control custom-checkbox item-custom-control mt-2">
                                                                    <input type="checkbox" className="custom-control-input" id="MakeDefchk" name="MakeDefchk" checked={this.state.MakeDefchk} onChange={(e) => this.OnHandleChange(e, "checkbox")} />
                                                                    <label className="custom-control-label" htmlFor="MakeDefchk">Make Default ?</label>
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                                <div className="col-md-12 float-left pl-2">
                                                    <button className="btn btn-primary custom-btn-primary primary-btn float-left" onClick={e => this.SubmitClick(e)}>Submit</button>
                                                </div>
                                            </div>
                                        </div> : null}
                                        {/*Item Info ends here*/}

                                    </div>
                                </div>


                                <div className="modal" id="TransferConfPopUp" >
                                    <div className="modal-dialog modal-lg custom-popup modal-dialog-centered">
                                        <div className="modal-content">
                                            {/* Modal Header */}
                                            <div className="modal-header bg-white border-0">
                                                <h2 className="mt-1 fav-item-title">Confirm Transfer</h2>
                                                <button type="button" className="btn close-btn bg-white" data-dismiss="modal">
                                                    X
                                                </button>
                                            </div>
                                            {/* Modal body */}
                                            <div className="modal-body pt-0">
                                                <div className="row">
                                                    <div className="col-auto mb-3">
                                                        <label className="catalog-label w-100">Item ID</label>
                                                        <label className="item-details-value  w-100">{this.state.ItemID}</label>
                                                    </div>
                                                    <div className="col-auto mb-3">
                                                        <label className="catalog-label w-100">BU </label>
                                                        <label className="item-details-value  w-100">{this.state.SelectedOrigBU}</label>
                                                    </div>
                                                    <div className="col-auto mb-3">
                                                        <label className="catalog-label w-100">QTY </label>
                                                        <label className="item-details-value  w-100">{this.state.TransQuantity}</label>
                                                    </div>
                                                </div>
                                                <div className="table-responsive">
                                                    <table className="table ZEUS_Grid FOM-grid mobileflex-grid">
                                                        <thead>
                                                            <tr>
                                                                <th>Level</th>
                                                                <th>From Location</th>
                                                                <th>To Location</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    Area</td>
                                                                <td>{this.state.SelectedOrigArea}</td>
                                                                <td>{this.state.SelectedDestArea.value}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    Aisle</td>
                                                                <td>{this.state.SelectedOrigAisle}</td>
                                                                <td>{this.state.SelectedDestAisle.value}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Row</td>
                                                                <td>{this.state.SelectedOrigRow}</td>
                                                                <td>{this.state.SelectedDestRow.value}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Shelf</td>
                                                                <td>{this.state.SelectedOrigShelf}</td>
                                                                <td>{this.state.SelectedDestShelf.value}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Bin</td>
                                                                <td>{this.state.SelectedOrigBin}</td>
                                                                <td>{this.state.SelectedDestBin.value}</td>
                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="col-md-12 text-right mb-4">
                                                <button className="btn btn-secondary custom-btn-custom-btn-secondary secondary-btn px-4 mr-2" data-dismiss="modal">Cancel</button>
                                                <button className="btn btn-primary custom-btn-primary primary-btn px-4" onClick={e => this.TransferConfClick(e)}>Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal" id="successpopup" >
                                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                                        <div className="modal-content">
                                            {/* Modal body */}
                                            <div className="modal-body">
                                                <div className="row justify-content-center">
                                                    <div className="col-md-12">
                                                        <div className="text-center mt-2">
                                                            {this.state.TransferMessage.includes("BintoBin Complete") ? <img src="Images/success-alert.png" alt="Transfer Success" /> : <img src="Images/close.png" alt="Transfer Failed" />}
                                                        </div>
                                                        <div className="text-center my-4">
                                                            <span className="info-label">{this.state.TransferMessage.includes("BintoBin Complete") ? "SUCCESS: Bin To Bin Transfer Completed" : this.state.TransferMessage}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 text-center mb-2">
                                                    <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={e => this.OkBtnClick(e)}>OK</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>) :
                            (

                                <div class="col-md-12 float-left  mb-3">
                                    <div className="row">
                                        {(this.state.itemDetailShow || this.state.CartData.length > 0) ? (
                                            <>
                                                <div className="col-md-3 mb-4">
                                                    <label className="form-label catalog-label" htmlFor="Employee-ID">
                                                        Employee name <span className="color-manditory">*</span>
                                                    </label>
                                                    <Select
                                                        options={this.state.TechNameDD}
                                                        value={this.state.TechNameValue}
                                                        onChange={e => this.HandleChangeDD(e, "Tech")}
                                                        name="Tech"
                                                    />
                                                </div>
                                                <div className="col-md-3 mb-4">
                                                    <label className="form-label catalog-label" htmlFor="Location-event">
                                                        Location <span className="color-manditory">*</span>
                                                    </label>
                                                    <Select
                                                        options={this.state.TruckidDD}
                                                        value={this.state.TruckidValue}
                                                        onChange={e => this.HandleChangeDD(e, "TruckID")}
                                                        name="TruckID"
                                                    />
                                                </div>
                                            </>
                                        ) : null}
                                    </div>

                                    {this.state.itemDetailShow && (
                                        <>
                                        <div className="custom-item-details-section mt-3">
                                            <h6 className="bin-transfer-table-title pl-3 pb-3 mb-0">Item  Details</h6>
                                            <div class="custom-item-details-container px-3">
                                                {this.renderCheckedItems()}
                                            </div>

                                        </div>

                                    <div className="d-flex justify-content-end my-4">
                                        {this.state.qtyitemmsg && (<div className="d-flex justify-content-end ">
                                            {this.state.qtyitemmsg && (
                                                <span className="alert-text-title text-danger" style={{ display: 'block' }}>
                                                    {this.state.qtyitemmsg}
                                                </span>
                                            )}
                                        </div>)}
                                        <button
                                            className="btn bin-transfer-item-detail-btn custom-btn-primary px-4"
                                            onClick={this.handleSave}
                                        >
                                            Save
                                        </button>
                                            </div>
                                    </>

                                    )}

                                    {this.state.CartData && this.state.CartData.length > 0 ? (
                                        <div className="col-md-12 mt-3 pl-2">
                                            <h6 className="bin-transfer-table-title">Transfer List</h6>
                                            <div className="table-responsive mt-3 bin-transfer-table-container">
                                                <table className="table ZEUS_Grid FOM-grid mobileresponsive-grid">
                                                    <thead>
                                                        <tr>
                                                            <th><span className="table-sort" onClick={(e) => { this.handleSort(e) }}>
                                                                Item ID {this.state.CartData.length > 1 ? (<img src="Images/table-sort-icon-bottom.svg" id="ITEM_ID" className='sort-icon asc' alt="sort-up" />) : null}
                                                            </span></th>
                                                            <th>Description</th>
                                                            <th >UOM</th>
                                                            <th>
                                                                <span onClick={(e) => { this.handleSort(e) }}>
                                                                    Serial ID {this.state.CartData.length > 1 ? (<img src="Images/table-sort-icon-bottom.svg" id="SERIAL_ID" className='sort-icon asc' alt="sort-up" />) : null}
                                                                </span>
                                                            </th>
                                                            <th className="text-end">Quantity</th>
                                                            <th className="text-center">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.bindCartData()}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    ) : (
                                            <div className=" pt-2">
                                                <div className="col-md-12 p-2 p-0 accept-transfer-container">
                                                    <div className="no-record-found-section">
                                                        <img src="Images/no-record-found.png" alt="select-file-to-view-img" className="no-record-found" />
                                                        <p className="font-14 mt-4 text-label-color custom-select-records">You have no items added to the transfer cart.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    {this.state.CartData && this.state.CartData.length > 0 && (
                                        <div className="mt-3 d-flex justify-content-between align-items-center pb-3">
                                            <label className="font-16 font-medium no-rec-color mb-0">
                                                Number of records: <span className="primary-textcolor">{this.state.CartData.length}</span>
                                            </label>

                                            {this.state.CartData.length > 10 && (
                                                <ReactPaginate
                                                    previousLabel={<span className="right-pagination-arrow" />}
                                                    nextLabel={<span className="left-pagination-arrow" />}
                                                    previousClassName="page-item"
                                                    nextClassName="page-item"
                                                    previousLinkClassName="page-link"
                                                    nextLinkClassName="page-link"
                                                    disabledClassName="disabled"
                                                    breakLabel="..."
                                                    breakClassName="page-item"
                                                    breakLinkClassName="page-link"
                                                    pageCount={this.state.pageCount}
                                                    marginPagesDisplayed={1}
                                                    pageRangeDisplayed={2}
                                                    onPageChange={this.handlePageClick}
                                                    containerClassName="custom-pagination pagination float-right"
                                                    pageClassName="page-item"
                                                    pageLinkClassName="page-link"
                                                    activeClassName="active"
                                                    hrefBuilder={() => '#'}
                                                    forcePage={this.state.PageNo - 1}
                                                />
                                            )}
                                        </div>
                                    )}

                                    {this.state.CartData && this.state.CartData.length > 0 && (<div class="d-flex justify-content-end pb-3 mt-4">
                                        <button class="btn custom-btn-secondary secondary-btn px-4 mr-3" onClick={() => this.showDeleteConfirmation('', true)}>Cancel</button>
                                        <button class="btn custom-btn-primary px-4" disabled={!(this.state.TruckidValue.value && this.state.TechNameValue.value)} onClick={() => this.TransferSubmitClick()}>Submit</button>
                                    </div>)}


                                    <div className="modal fade bin-transfer-container" id="TransferEditPopUp" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div className="modal-dialog modal-lg custom-popup modal-dialog-centered" role="document">
                                            <div className="modal-content custom-container border-0">
                                                <div className="modal-header align-items-center">
                                                    <h5 className="fav-item-title m-0  fSoftware-Inventory-servicenowont-18 font-medium">Edit transfer</h5>
                                                    <button type="button" className="btn py-0" data-dismiss="modal">
                                                        <img src="images/close-icon.svg" alt="close-icon" />
                                                    </button>
                                                </div>
                                                <div className="modal-body terms-scroll m-4 pt-0 popup-info-container">
                                                    <div className="row">
                                                        {this.state.TransferEditPopUp ? (
                                                            <div className="custom-item-details-section w-100">
                                                                <h6 className="bin-transfer-table-title">Item  Details</h6>
                                                                <div className="col-lg-12 col-md-9">
                                                                    <div className="row d-flex align-items-center">
                                                                        <div className="col-lg-6 col-md-12 p-0">
                                                                            <div className="mb-2">
                                                                                <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                                                                    Item ID : <span className="app-enhancements-sub-content ml-3">{this.state.TransferEditPopUp.ITEM_ID}</span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-6 col-md-12 p-0">
                                                                            <div className="mb-2">
                                                                                <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                                                                    Description : <span className="app-enhancements-sub-content ml-2">{this.state.TransferEditPopUp.DESCR254}</span>
                                                                                </p>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-6 col-md-12 p-0">
                                                                            <div className="mb-2">
                                                                                <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                                                                    Serial ID : <span className="app-enhancements-sub-content ml-2">{this.state.TransferEditPopUp.SERIAL_ID}</span>
                                                                                </p>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-6 col-md-12 p-0">
                                                                            <div className="mb-2">
                                                                                <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                                                                    QTY available : <span className="app-enhancements-sub-content ml-2">{this.state.TransferEditPopUp.QtyAvailable}</span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-6 col-md-12 p-0">
                                                                            <div className="mb-2">
                                                                                <p className="font-14 app-enhancements-main-content mb-0 text-wrap">
                                                                                    UOM : <span className="app-enhancements-sub-content ml-2">{this.state.TransferEditPopUp.UOM}</span>
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                        <div className="col-md-12 mt-3 p-0">
                                                            <div className="custom-product-add-cart justify-content-start p-0 mb-2">
                                                                <p className="font-14 app-enhancements-main-content mb-0 text-wrap app-enhancements-sub-content font-medium">Quantity to transfer</p>
                                                                <form id="myform" method="POST" className="quantity font-12" action="#">
                                                                    <input type="button" value="-" className="qtyminus noborderbin minus" onClick={(e) => this.handleEditQtyChange('decrement', e)} disabled={this.state.TransferEditPopUp && this.state.TransferEditPopUp.QUANTITY === 1} />
                                                                    <input type="text" name="quantity" maxLength="5" onChange={(e) => this.handleEditQtyChange('text', e)} onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                        }
                                                                    }} value={this.state.TransferEditPopUp ? this.state.TransferEditPopUp.QUANTITY : 0} className="qty noborderbin" style={{ outline: '0px !important' }} />
                                                                    <input type="button" value="+" className="qtyplus noborderbin  plus" onClick={(e) => this.handleEditQtyChange('increment', e)} disabled={this.state.TransferEditPopUp && this.state.TransferEditPopUp.QUANTITY >= this.state.TransferEditPopUp.QtyAvailable} />
                                                                </form>
                                                            </div>
                                                        </div>

                                                        <div className="d-flex justify-content-end mt-4 w-100">
                                                            {this.state.qtymsg && (
                                                                <span className="alert-text-title">{this.state.qtymsg}</span>
                                                            )}
                                                        </div>
                                                        <div className="d-flex justify-content-end mt-4 w-100">
                                                            <button className="btn custom-btn-secondary secondary-btn px-4 mr-3" data-dismiss="modal">Cancel</button>
                                                            <button className="btn custom-btn-primary px-4" onClick={this.UpdateTransferAction}>Save</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    <div className="modal fade" id="deleteConfirmationPopup" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" data-backdrop="static" aria-hidden="true">
                                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-body">
                                                    <div className="row text-center">
                                                        <div className="col-md-12 my-4">
                                                            <span className="question-mark-icon delete-confirm-icon"></span>
                                                        </div>
                                                        <div className="col-12 mb-4">
                                                            <label className="confirm-label d-block">Confirm</label>
                                                            <label className="confirm-content d-block">{this.state.confirmationMessage}</label>
                                                        </div>
                                                        <div className="col-md-12 text-center mb-2">
                                                            <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.handleDeleteItem(false)}>No</button>
                                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.handleDeleteItem(true)}>Yes</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal" id="bintobinitemalready" data-backdrop="static" data-keyboard="false">
                                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                                            <div className="modal-content">
                                                {/* Modal Header */}
                                                <div className="modal-header">
                                                    <h4 className="modal-title mt-1 shoppingcart-popup-title">Confirmation</h4>
                                                </div>
                                                {/* Modal body */}
                                                <div className="modal-body" >
                                                    <div className="row text-center">
                                                        <div className="col-12 mb-4">
                                                            <label className="confirm-content d-block">The items listed below are already in the cart. You can update directly in the cart</label>
                                                        </div>
                                                        <div className="col-12 mb-4" id="modal-unavailable">
                                                            {this.RemoveItemDetails("itemsalreadymap")}
                                                        </div>

                                                        <div className="col-md-12 text-center mb-2">
                                                            <button className="btn btn-primary custom-btn-primary primary-btn mr-3 px-5" data-dismiss="modal" onClick={() => this.RemoveItemDetails("removeitemsalready")}><Trans>OK</Trans></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal" id="successpopup" data-backdrop="static">
                                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                                            <div className="modal-content">
                                                <div className="modal-body">
                                                    <div className="row justify-content-center">
                                                        <div className="col-md-12">
                                                            <div className="text-center mt-2">
                                                                <div className="col-md-12 my-4">
                                                                    <span className="question-mark-icon success-alert-icon" />
                                                                </div>
                                                                <div className="text-center my-4">
                                                                    <p class="confirm-label d-block"><Trans>Order</Trans><span> </span><Trans>No</Trans><span>:</span><span className="mx-2">{this.state.orderNumber}</span></p>
                                                                    <span className="confirm-label d-block">A Transfer request has been raised Successfully</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 text-center mb-2">
                                                            <button
                                                                className="btn btn-primary custom-btn-primary primary-btn px-5"
                                                                data-dismiss="modal"
                                                                onClick={() => this.navigateToFieldInventory()}
                                                            >
                                                                OK
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal fade" id="bintobinmixedcart" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                                        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                                            <div className="modal-content border-0">
                                                <div className="modal-header sp-delv-header align-items-center px-4">
                                                    <h5 className="modal-title" id="exampleModalLongTitle">Confirmation</h5>
                                                </div>
                                                <div className="modal-body font-15 px-4">
                                                    Adding this item will clear your stock transfer cart due to different truck/rack IDs. Do you want to proceed with this change?
            </div>
                                                <div className="modal-footer border-0 px-4">
                                                    <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4" type="button" data-dismiss="modal" onClick={this.handleBinToBinNo}>No</button>
                                                    <button className="btn btn-custom-primary font-14 font-medium px-4" type="button" onClick={this.handleBinToBinYes}>Yes</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="modal" id="QTY-popupbintobin" data-backdrop="static" data-keyboard="false">
                                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h4 className="modal-title mt-1" />
                                                    <button type="button" className="btn close-btn" data-dismiss="modal" >
                                                        X
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="row text-center">
                                                        <div className="col-md-12 my-4">
                                                            <span className="question-mark-icon delete-confirm-icon" />
                                                        </div>
                                                        <div className="col-12 mb-4">
                                                            <label className="confirm-label d-block"><Trans>Confirm</Trans></label>
                                                            {this.NAItems()}
                                                        </div>
                                                        <div className="col-12 mb-4">
                                                            <label className="confirm-content d-block"><Trans>Item Quantity not available. To place the order change the quantity or remove the item.</Trans></label>
                                                        </div>
                                                        <div className="col-md-12 text-center mb-2">
                                                            <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-3" data-dismiss="modal" onClick={() => this.QTYNA("1")}><Trans>Remove these items</Trans></button>
                                                            <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.QTYNA("2")} ><Trans>Apply Change</Trans></button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>


                                

                            )}
                    </div>
                </div>
            </div>

        );
    };
}
export default withTranslation()(BinToBinComponent);